import axios from "axios";

export interface SupportedLanguage {
   id: string;
   name: string;
   emoji: string;
}

// Data returned by the '/client-settings' endpoint
export declare interface ClientSettingsResponse {
   // Platform experience
   EXTERNAL_CONTRIBUTIONS_ENABLED: boolean;
   INTERCOM_ENABLED: boolean;
   INTERCOM_APP_ID: string;
   TRAIT_REPORTS_ENABLED: boolean;
   USER_DOCUMENTS_ENABLED: boolean;
   COOKIES_DATE_CHANGED: string | null;
   // Registration and login
   PORTAL_INVITATION_ONLY_REGISTRATION: boolean;
   REGISTRATION_CODE_REQUIRED: boolean;
   SIGNUP_ENABLED: boolean;
   REQUIRE_CORE_PROFILE_ON_LOGIN: boolean;
   GOOGLE_SIGN_IN_ENABLED: boolean;
   // Languages
   DEFAULT_LANGUAGE: string; // locale_id (e.g., en-gb)
   SUPPORTED_LANGUAGES: SupportedLanguage[];
   // Analytics
   META_PIXEL_ANALYTICS_ENABLED: boolean;
   PLAUSIBLE_ANALYTICS_ENABLED: boolean;
   GOOGLE_ANALYTICS_ENABLED: boolean;
   GOOGLE_ANALYTICS_CODE: string;
}

export default class ClientSettingsApi {
   public static get = async (): Promise<ClientSettingsResponse> => {
      const response = await axios.get("/client-settings", { ignoreCamelConversion: true } as any);
      return response.data.data;
   };
}
